import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Refresh-токена в JS больше нет (его ведёт бэкенд в httpOnly cookie), поэтому на 401 мы не
 * пытаемся обновлять токен, а считаем сессию истёкшей. Запросы к /auth/web/* (логин, зондирование
 * каналов) сами интерпретируют свои 401 и глобальный выход не вызывают.
 */
export const tokenRefreshInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !req.url.includes('/auth/web/') && authService.isAuthenticated()) {
        authService.handleSessionExpired();
      }
      return throwError(() => error);
    })
  );
};
